/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* VUEX
-------------------------------------------------------------- */
import Vuex from 'vuex';

Vue.use(Vuex);

/* VUE-AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '@/router';

Vue.use(Vuex, VueAxios, axios);
